import * as Bixby from '$/core';

export const TOAST_INFO = 'TOAST_INFO';
export const TOAST_WARNING = 'TOAST_WARNING';
export const TOAST_SUCCESS = 'TOAST_SUCCESS';
export const TOAST_ERROR = 'TOAST_ERROR';

interface ToastInfo extends Bixby.Models.BixbyAction {
  type: typeof TOAST_INFO;
}
interface ToastWarning extends Bixby.Models.BixbyAction {
  type: typeof TOAST_WARNING;
}
interface ToastSuccess extends Bixby.Models.BixbyAction {
  type: typeof TOAST_SUCCESS;
}
interface ToastError extends Bixby.Models.BixbyAction {
  type: typeof TOAST_ERROR;
}

export type ToastActionTypes = ToastInfo | ToastWarning | ToastSuccess | ToastError;
